// Single source of truth for county dropdown + map zoom bounds.
// Bounds are [west, south, east, north] from ST_Extent(geom) on parcels table.

export interface CountyEntry {
  label: string;
  value: string;
  bounds: [number, number, number, number];
}

export const COUNTIES: CountyEntry[] = [
  // Texas
  { label: 'Andrews, TX',     value: 'Andrews',    bounds: [-103.0648, 32.0858, -102.2015, 32.5276] },
  { label: 'Crane, TX',       value: 'Crane',      bounds: [-102.7677, 31.0860, -102.3010, 31.6515] },
  { label: 'Culberson, TX',   value: 'Culberson',  bounds: [-104.9188, 30.6636, -104.0246, 32.0006] },
  { label: 'Ector, TX',       value: 'Ector',      bounds: [-102.7979, 31.6508, -102.2867, 32.0875] },
  { label: 'Gaines, TX',      value: 'Gaines',     bounds: [-102.5602, 32.5229, -102.2029, 32.6750] },
  { label: 'Howard, TX',      value: 'Howard',     bounds: [-101.6950, 32.0871, -101.1745, 32.5252] },
  { label: 'Hudspeth, TX',    value: 'Hudspeth',   bounds: [-105.9981, 30.6294, -104.9073, 32.0026] },
  { label: 'Jeff Davis, TX',  value: 'Jeff Davis',  bounds: [-104.9806, 30.4122, -103.4400, 31.1052] },
  { label: 'Loving, TX',      value: 'Loving',     bounds: [-103.9834, 31.6504, -103.3269, 32.0005] },
  { label: 'Martin, TX',      value: 'Martin',     bounds: [-102.2118, 32.0817, -101.6801, 32.5311] },
  { label: 'Midland, TX',     value: 'Midland',    bounds: [-102.2876, 31.6513, -101.7716, 32.1276] },
  { label: 'Pecos, TX',       value: 'Pecos',      bounds: [-103.5829, 30.0591, -101.7710, 31.3700] },
  { label: 'Reeves, TX',      value: 'Reeves',     bounds: [-104.1016, 30.7682, -103.0122, 32.0003] },
  { label: 'Shackelford, TX', value: 'Shackelford', bounds: [-99.6123, 32.5147, -99.0957, 32.9571] },
  { label: 'Upton, TX',       value: 'Upton',      bounds: [-102.3179, 31.0798, -101.7750, 31.6517] },
  { label: 'Ward, TX',        value: 'Ward',       bounds: [-103.6107, 31.2670, -102.7675, 31.6561] },
  { label: 'Winkler, TX',     value: 'Winkler',    bounds: [-103.3275, 31.6513, -102.7985, 32.0870] },
  // West Virginia
  { label: 'Harrison, WV',    value: 'Harrison',   bounds: [-80.3855, 39.1005, -80.1608, 39.3815] },
  // New Mexico
  { label: 'Chaves, NM',      value: 'Chaves',     bounds: [-105.3540, 32.5188, -103.5095, 34.0888] },
  { label: 'Cibola, NM',      value: 'Cibola',     bounds: [-109.0462, 34.5778, -107.0678, 35.3484] },
  { label: 'Eddy, NM',        value: 'Eddy',       bounds: [-104.8518, 32.0000, -103.7229, 32.9654] },
  { label: 'Lea, NM',         value: 'Lea',        bounds: [-103.8146, 32.0002, -103.0527, 33.5706] },
  { label: 'Lincoln, NM',     value: 'Lincoln',    bounds: [-106.1250, 33.1319, -104.8849, 34.3475] },
  { label: 'Socorro, NM',     value: 'Socorro',    bounds: [-107.7254, 33.4780, -105.9247, 34.5806] },
  { label: 'Torrance, NM',    value: 'Torrance',   bounds: [-106.4711, 34.2598, -105.2903, 35.0421] },
  { label: 'Valencia, NM',    value: 'Valencia',   bounds: [-107.2045, 34.4370, -106.4104, 34.9578] },
];

// Lookup by county value for map zoom
export const COUNTY_BOUNDS: Record<string, [number, number, number, number]> =
  Object.fromEntries(COUNTIES.map(c => [c.value, c.bounds]));
